//
// Autogenerated by Thrift Compiler (0.12.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require('thrift');
var Thrift = thrift.Thrift;
var Q = thrift.Q;


var ttypes = module.exports = {};
var LockedObject = module.exports.LockedObject = function(args) {
  this.encryptedData = null;
  this.version = null;
  this.encryptionPolicy = null;
  this.encryptionMode = null;
  this.iv = null;
  this.counter = null;
  this.groupId = null;
  this.keyGenerationPolicy = null;
  this.encryptedDEK = null;
  this.chainKGPRandomNo = null;
  this.iterationNumber = null;
  this.senderId = null;
  this.recipientId = null;
  this.senderDetail = null;
  this.publicKey = null;
  if (args) {
    if (args.encryptedData !== undefined && args.encryptedData !== null) {
      this.encryptedData = args.encryptedData;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field encryptedData is unset!');
    }
    if (args.version !== undefined && args.version !== null) {
      this.version = args.version;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field version is unset!');
    }
    if (args.encryptionPolicy !== undefined && args.encryptionPolicy !== null) {
      this.encryptionPolicy = args.encryptionPolicy;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field encryptionPolicy is unset!');
    }
    if (args.encryptionMode !== undefined && args.encryptionMode !== null) {
      this.encryptionMode = args.encryptionMode;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field encryptionMode is unset!');
    }
    if (args.iv !== undefined && args.iv !== null) {
      this.iv = args.iv;
    }
    if (args.counter !== undefined && args.counter !== null) {
      this.counter = args.counter;
    }
    if (args.groupId !== undefined && args.groupId !== null) {
      this.groupId = args.groupId;
    }
    if (args.keyGenerationPolicy !== undefined && args.keyGenerationPolicy !== null) {
      this.keyGenerationPolicy = args.keyGenerationPolicy;
    }
    if (args.encryptedDEK !== undefined && args.encryptedDEK !== null) {
      this.encryptedDEK = args.encryptedDEK;
    }
    if (args.chainKGPRandomNo !== undefined && args.chainKGPRandomNo !== null) {
      this.chainKGPRandomNo = args.chainKGPRandomNo;
    }
    if (args.iterationNumber !== undefined && args.iterationNumber !== null) {
      this.iterationNumber = args.iterationNumber;
    }
    if (args.senderId !== undefined && args.senderId !== null) {
      this.senderId = args.senderId;
    }
    if (args.recipientId !== undefined && args.recipientId !== null) {
      this.recipientId = args.recipientId;
    }
    if (args.senderDetail !== undefined && args.senderDetail !== null) {
      this.senderDetail = args.senderDetail;
    }
    if (args.publicKey !== undefined && args.publicKey !== null) {
      this.publicKey = args.publicKey;
    }
  }
};
LockedObject.prototype = {};
LockedObject.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.encryptedData = input.readBinary();
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.I32) {
        this.version = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.I32) {
        this.encryptionPolicy = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.I32) {
        this.encryptionMode = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRING) {
        this.iv = input.readBinary();
      } else {
        input.skip(ftype);
      }
      break;
      case 6:
      if (ftype == Thrift.Type.I64) {
        this.counter = input.readI64();
      } else {
        input.skip(ftype);
      }
      break;
      case 7:
      if (ftype == Thrift.Type.STRING) {
        this.groupId = input.readString();
      } else {
        input.skip(ftype);
      }
      break;
      case 8:
      if (ftype == Thrift.Type.I32) {
        this.keyGenerationPolicy = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 9:
      if (ftype == Thrift.Type.STRING) {
        this.encryptedDEK = input.readBinary();
      } else {
        input.skip(ftype);
      }
      break;
      case 10:
      if (ftype == Thrift.Type.I64) {
        this.chainKGPRandomNo = input.readI64();
      } else {
        input.skip(ftype);
      }
      break;
      case 11:
      if (ftype == Thrift.Type.I32) {
        this.iterationNumber = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 12:
      if (ftype == Thrift.Type.I32) {
        this.senderId = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 13:
      if (ftype == Thrift.Type.I32) {
        this.recipientId = input.readI32();
      } else {
        input.skip(ftype);
      }
      break;
      case 14:
      if (ftype == Thrift.Type.STRING) {
        this.senderDetail = input.readString();
      } else {
        input.skip(ftype);
      }
      break;
      case 15:
      if (ftype == Thrift.Type.STRING) {
        this.publicKey = input.readString();
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

LockedObject.prototype.write = function(output) {
  output.writeStructBegin('LockedObject');
  if (this.encryptedData !== null && this.encryptedData !== undefined) {
    output.writeFieldBegin('encryptedData', Thrift.Type.STRING, 1);
    output.writeBinary(this.encryptedData);
    output.writeFieldEnd();
  }
  if (this.version !== null && this.version !== undefined) {
    output.writeFieldBegin('version', Thrift.Type.I32, 2);
    output.writeI32(this.version);
    output.writeFieldEnd();
  }
  if (this.encryptionPolicy !== null && this.encryptionPolicy !== undefined) {
    output.writeFieldBegin('encryptionPolicy', Thrift.Type.I32, 3);
    output.writeI32(this.encryptionPolicy);
    output.writeFieldEnd();
  }
  if (this.encryptionMode !== null && this.encryptionMode !== undefined) {
    output.writeFieldBegin('encryptionMode', Thrift.Type.I32, 4);
    output.writeI32(this.encryptionMode);
    output.writeFieldEnd();
  }
  if (this.iv !== null && this.iv !== undefined) {
    output.writeFieldBegin('iv', Thrift.Type.STRING, 5);
    output.writeBinary(this.iv);
    output.writeFieldEnd();
  }
  if (this.counter !== null && this.counter !== undefined) {
    output.writeFieldBegin('counter', Thrift.Type.I64, 6);
    output.writeI64(this.counter);
    output.writeFieldEnd();
  }
  if (this.groupId !== null && this.groupId !== undefined) {
    output.writeFieldBegin('groupId', Thrift.Type.STRING, 7);
    output.writeString(this.groupId);
    output.writeFieldEnd();
  }
  if (this.keyGenerationPolicy !== null && this.keyGenerationPolicy !== undefined) {
    output.writeFieldBegin('keyGenerationPolicy', Thrift.Type.I32, 8);
    output.writeI32(this.keyGenerationPolicy);
    output.writeFieldEnd();
  }
  if (this.encryptedDEK !== null && this.encryptedDEK !== undefined) {
    output.writeFieldBegin('encryptedDEK', Thrift.Type.STRING, 9);
    output.writeBinary(this.encryptedDEK);
    output.writeFieldEnd();
  }
  if (this.chainKGPRandomNo !== null && this.chainKGPRandomNo !== undefined) {
    output.writeFieldBegin('chainKGPRandomNo', Thrift.Type.I64, 10);
    output.writeI64(this.chainKGPRandomNo);
    output.writeFieldEnd();
  }
  if (this.iterationNumber !== null && this.iterationNumber !== undefined) {
    output.writeFieldBegin('iterationNumber', Thrift.Type.I32, 11);
    output.writeI32(this.iterationNumber);
    output.writeFieldEnd();
  }
  if (this.senderId !== null && this.senderId !== undefined) {
    output.writeFieldBegin('senderId', Thrift.Type.I32, 12);
    output.writeI32(this.senderId);
    output.writeFieldEnd();
  }
  if (this.recipientId !== null && this.recipientId !== undefined) {
    output.writeFieldBegin('recipientId', Thrift.Type.I32, 13);
    output.writeI32(this.recipientId);
    output.writeFieldEnd();
  }
  if (this.senderDetail !== null && this.senderDetail !== undefined) {
    output.writeFieldBegin('senderDetail', Thrift.Type.STRING, 14);
    output.writeString(this.senderDetail);
    output.writeFieldEnd();
  }
  if (this.publicKey !== null && this.publicKey !== undefined) {
    output.writeFieldBegin('publicKey', Thrift.Type.STRING, 15);
    output.writeString(this.publicKey);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

